import { render, staticRenderFns } from "./TopBarNotice.vue?vue&type=template&id=5ef0da68"
import script from "./TopBarNotice.vue?vue&type=script&lang=js"
export * from "./TopBarNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports